// 免登录设备标识：写作订单、答辩PPT任务按它归属到当前浏览器
const GUEST_KEY = 'lgfb.guestId';

const randomId = () => {
    if (window.crypto?.randomUUID) return window.crypto.randomUUID().replace(/-/g, '');
    let id = '';
    for (let i = 0; i < 32; i += 1) id += Math.floor(Math.random() * 16).toString(16);
    return id;
};

let cached = '';

export const getGuestId = () => {
    if (cached) return cached;
    try {
        cached = window.localStorage.getItem(GUEST_KEY) || '';
        if (!/^[A-Za-z0-9_-]{16,64}$/.test(cached)) {
            cached = randomId();
            window.localStorage.setItem(GUEST_KEY, cached);
        }
    } catch {
        cached = cached || randomId();
    }
    return cached;
};

export const guestHeaders = () => ({ 'X-Guest-Id': getGuestId() });
